import { createCustomEnum } from "./customEnum";

const StatusPaymentMethodTypes = createCustomEnum({
	Active: {
		value: 1,
		name: "active",
		displayName: "Active",
	},
	Inactive: {
		value: 0,
		name: "inactive",
		displayName: "Inactive",
	},
});

export default StatusPaymentMethodTypes;
